export default __webpack_public_path__ + "static/media/avatar-1.e18c937d.svg";